import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-info-item',
    templateUrl: './info-item.component.html',
    styleUrls: ['./info-item.component.less'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class InfoItemComponent {
    label = input<string>('');
    value = input<string | undefined>(undefined);
    icon  = input<string | undefined>(undefined);
    inline = input<boolean>(false);
}
